import { version } from '../package.json';
import { normalize } from './normalize';
export { compile } from './compile/compile';
export * from './util';
export { normalize, version };
//# sourceMappingURL=index.js.map